/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani
 * @Date 6/10/2023
 */

import React from 'react'

import serviceImage from "../../assets/images/services/bpm1.png";
import Styles from "./servicesBox.module.css";
import { Typography } from '@mui/material';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import { blue } from '@mui/material/colors';

// import Styles from "./products.module.css";



const ServiceBox = () => {

    return (
        <>
         <div className={Styles.OueterContent}>
            <Typography variant='h4' className={Styles.mainHeadertxt}>Web Designing</Typography>
            <div className={Styles.titelUnderLine}></div>
            <div className={Styles.cardAndBodyFlex}>
                
                <div className={Styles.serviceImgMainComp}>
                    <div className={Styles.serviceCardCmp3}>
                    </div>
                </div>
                <div className={Styles.cardBodyContent}>
                    <Typography variant='body1' className={Styles.contentBodytxt}> Website designing is the process of creating visually appealing and functional websites that engage users and effectively convey a message, provide information, or facilitate a desired action. It involves a combination of creative design elements, user experience considerations, and technical expertise to develop a website that aligns with the goals and brand identity of a business or individual.</Typography>
                    <Typography className={Styles.titelFirsttxt} >Features</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Design and Layout</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> User Experience (UX) Design</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Responsive Design</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Information Architecture</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> SEO Integration</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Feedback and Iteration</Typography>

                </div>
            </div>

        </div>

        <div className={Styles.OueterContent2}>
            <Typography variant='h4' className={Styles.mainHeadertxt}>Tailor-made software solutions</Typography>
            <div className={Styles.titelUnderLine}></div>
            <div className={Styles.cardAndBodyFlex1}>
            <div className={Styles.cardBodyContent}>
                    <Typography variant='body1' className={Styles.contentBodytxt}>Tailor-made software solutions, also known as custom software solutions or bespoke software, are software applications or systems specifically designed, developed, and tailored to meet the unique requirements, preferences, and needs of a particular organization, business, or individual.</Typography>
                    <Typography className={Styles.titelFirsttxt} >Features</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Customized to Specific Needs</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Security and Compliance</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Cost-Effectiveness</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Support and Maintenance</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> User-Focused Design</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Competitive Advantage</Typography>

                </div>
                <div className={Styles.serviceImgMainComp}>  
                    <div className={Styles.serviceCardCmp2}>
                    </div>  
                </div>
                
            </div>

        </div>

        <div className={Styles.OueterContent} >
            <Typography variant='h4' className={Styles.mainHeadertxt}>Business Process Management (BPM) </Typography>
            <div className={Styles.titelUnderLine}></div>
            <div className={Styles.cardAndBodyFlex}>
                
                <div className={Styles.serviceImgMainComp}>
                    <div className={Styles.serviceCardCmp1}>
                    </div>
                </div>
                <div className={Styles.cardBodyContent}>
                    <Typography variant='body1' className={Styles.contentBodytxt}>Business Process Management (BPM) is a strategic approach that focuses on identifying, analyzing, designing, implementing, monitoring, and continuously improving business processes within an organization to achieve enhanced efficiency, effectiveness, agility, and overall performance. It involves a systematic method of managing and optimizing workflows, business rules, data, and interactions to align with organizational goals and improve operational outcomes.</Typography>
                    <Typography className={Styles.titelFirsttxt} >Features</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Process Identification and Documentation</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Process Analysis and Modeling</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Process Redesign and Optimization</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Automation and Implementation</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Monitoring and Performance Measurement</Typography>
                    <Typography variant='body2' className={Styles.contentFeaturesPoints}><LocalLibraryIcon color={blue[200]} /> Customer-Centric Focus</Typography>

                </div>
            </div>

        </div>

        </>
       
    )
}

export default ServiceBox;
